import ReactDOM from 'react-dom/client';
import App from './App';
import WidgetView from './components/App/WidgetView';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <App>
    <WidgetView />
  </App>,
  // </React.StrictMode>
);
